// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__xVZBl","links":"NavBar_links__x5vrC","link":"NavBar_link__iA-1f","current":"NavBar_current__fw4aO"};